import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.908 5.742a.825.825 0 1 0-1.166 1.166L9.833 11l-4.091 4.092a.825.825 0 0 0 1.166 1.166L11 12.167l4.092 4.091a.825.825 0 0 0 1.166-1.166L12.167 11l4.091-4.092a.825.825 0 0 0-1.166-1.166L11 9.833 6.908 5.742Z",
  fill: "#02504B"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }